import { errorHandler } from '@/app/shared/services/error-handler.js';
import taskCategoriesService from '../admin/tasks/taskCategoriesService';
import tasksService from '../admin/tasks/tasksService';
import employeeTitleService from '../admin/employeeTitles/employeeTitleService';
import coreBarrelsService from '../admin/coreBarrels/coreBarrelService';
import instrumentService from '../admin/instruments/instrumentService';

export default {
  //#region Holes
  fetchAllHoles({ commit }, mainProjectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("Drilling/Holes/FindAll", { params: { mainProjectId }})
        .then((response) => {
          commit('SET_HOLES', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  setEndOfHole({ commit }, data) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost("Drilling/Holes/SetIsEndOfHole", { holeId: data.holeId, isEndOfHole: data.isEndOfHole })
        .then((response) => {
          commit('UPDATE_HOLE', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addHole({ commit }, hole) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('Drilling/Holes/CreateAsDto', { hole })
        .then((response) => {
          commit('ADD_HOLE', response.data.model)
          hole.holeId = response.data.model.holeId;
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },

  //#endregion

  //#region Drills
  fetchAllDrills({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsGet("Drilling/DrillRigs/FindAll")
        .then((response) => {
          commit('SET_DRILLS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addDrill({ commit }, item) {
    return new Promise((resolve, reject) => {      
      this._vm.$cqrsPost("Drilling/DrillRigs/create", { DrillRig: item })
        .then((response) => {
          commit('ADD_DRILL', Object.assign(item, { drillRigId: response.data.model.drillRigId }))
          resolve(response)
        })
        .catch((error) => {
          reject(error); 
        })
    })
  },

  updateDrill({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost("Drilling/DrillRigs/edit", { DrillRig: item })
        .then((response) => {
          commit('UPDATE_DRILL', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },

  removeDrill({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost("Drilling/DrillRigs/delete", { id })
        .then((response) => {
          commit('REMOVE_DRILL', id)
          resolve(response)
        })
        .catch((error) => {
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Contracts
  fetchAllContracts({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsGet("Drilling/Contracts/FindAll")
        .then((response) => {
          commit('SET_CONTRACTS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  addContract({ commit }, contract) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('Drilling/Contracts/Create', { contract })
        .then((response) => {
          commit('ADD_CONTRACT', Object.assign(contract, { contractId: response.data.model.contractId }))
          resolve(response)
        })
        .catch((error) => {
          errorHandler.savingError(this._vm, error);
          reject(error); 
        })
    })
  },

  updateContract({ commit }, contract) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('Drilling/Contracts/Edit', { contract })
        .then((response) => {
          commit('UPDATE_CONTRACT', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },

  removeContract({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('Drilling/Contracts/Delete', { Id: itemId })
        .then((response) => {
          commit('REMOVE_CONTRACT', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },

  //#endregion

  //#region Companies

  fetchAllCompanies({ commit }) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsGet("Drilling/Companies/FindAll").then((response) => {
        commit('SET_COMPANIES', response.data.model)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  addCompany({ commit }, company) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost("Drilling/Companies/create", { company })
        .then((response) => {
          commit('ADD_COMPANY', Object.assign(company, { companyId: response.data.model.companyId }))
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  updateCompany({ commit }, company) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost("Drilling/Companies/Edit", { company })
        .then((response) => {
          commit('UPDATE_COMPANY', response.data.model)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  removeCompany({ commit }, id) {
    return new Promise((resolve, reject) => {

      this._vm.$cqrsPost('Drilling/Companies/Delete', { id })
        .then((response) => {
          commit('REMOVE_COMPANY', id)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  //#endregion

  //#region Projects
  fetchAllProjects({ commit }, mainProjectId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsGet("Drilling/Projects/FindAll", { params: { mainProjectId }}).then((response) => {
        commit('SET_PROJECTS', response.data.model)
        resolve(response)
      }).catch((error) => {
        errorHandler.loadingError(this._vm, error);
        reject(error)
      })
    })
  },

  fetchAllProjectCodes({ commit, state }, force = false) {
    return new Promise((resolve, reject) => {
      if (!force && state.projectCodes.length > 0) {
        resolve(state.projectCodes)
        return
      }
      this._vm.$cqrsGet("Drilling/Projects/FindAllCodes").then((response) => {
        commit('SET_PROJECT_CODES', response.data.model)
        resolve(response.data.model)
      }).catch((error) => {
        errorHandler.loadingError(this._vm, error);
        reject(error)
      })
    })
  },

  removeProject({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      this._vm.$cqrsPost('Drilling/Projects/Delete', { Id: itemId })
        .then((response) => {
          commit('REMOVE_PROJECT', itemId)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  //#endregion

  //#region Task Categories and Tasks
  fetchAllCategories({ commit }) {
    return new Promise((resolve, reject) => {
      taskCategoriesService.findAll(this._vm)
        .then((response) => {
          commit('SET_TASK_CATEGORIES', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  fetchAllCategoriesByProjectId({ commit }, mainProjectId) {
    return new Promise((resolve, reject) => {
      taskCategoriesService.findAllByProjectId(this._vm, mainProjectId)
        .then((response) => {
          commit('SET_TASK_CATEGORIES_PREFERRED', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  addCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      return taskCategoriesService.add(category, this._vm)
        .then((response) => {
          commit('ADD_TASK_CATEGORY', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  updateCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      return taskCategoriesService.edit(category, this._vm)
        .then((response) => {
          commit('UPDATE_TASK_CATEGORY', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      return taskCategoriesService.delete(id, this._vm)
        .then((response) => {
          commit('REMOVE_TASK_CATEGORY', id)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  addTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      return tasksService.add(task, this._vm)
        .then((response) => {
          commit('ADD_TASK', Object.assign(task, { id: response.data.model.id }))
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  updateTask({ commit }, task) {
    return new Promise((resolve, reject) => {
      return tasksService.edit(task, this._vm)
        .then((response) => {
          commit('UPDATE_TASK', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.savingError(this._vm, error);
          reject(error) 
        })
    })
  },
  removeTask({ commit }, ids) {
    return new Promise((resolve, reject) => {
      return tasksService.delete(ids.id, this._vm)
        .then((response) => {
          commit('REMOVE_TASK', ids)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  //#endregion

  //#region Employee titles
  fetchAllEmployeeTitles({ commit }) {
    return new Promise((resolve, reject) => {
      employeeTitleService.fetchAll(this._vm)
        .then((response) => {
          commit('SET_EMPLOYEE_TITLES', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  },
  //#endregion

  //#region Staging Daily Reports
  setStagingDailyReportsSelectedDate({commit}, selectedDate) {
    commit('SET_STAGING_DAILY_REPORT_SELECTED_DATE', selectedDate);
  },
  //#endregion
  
  //#region CoreBarrels
  fetchAllCoreBarrels({ commit }) {
    return new Promise((resolve, reject) => {
      coreBarrelsService.fetchAll(this._vm)
        .then((response) => {
          commit('SET_CORE_BARRELS', response.data.model)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.loadingError(this._vm, error);
          reject(error)
        })
    })
  },
  //#endregion

  //#region Instruments
  fetchAllInstruments({ commit }) {
    return new Promise((resolve, reject) => {
      instrumentService.fetchAll(this._vm)
        .then((response) => {
          commit('SET_INSTRUMENTS', response.data.model)
          resolve(response)
        })
        .catch((error) => { 
          errorHandler.deletingError(this._vm, error);
          reject(error) 
        })
    })
  }
  //#endregion

}
